import swal from "sweetalert";

/**
 * Confirmation d'un envoi SAV (SMS / email) ET question « retard ? » en une
 * seule fenêtre. Oui comme Non envoient : l'agent doit répondre, rien n'est
 * pré-choisi. Un message de retard est aussi montré au client dans l'app, sur
 * le suivi de sa commande (« Incident », API isDelay).
 *
 * Contenu passé en élément et non en `text` : sweetalert 2 ignore les retours
 * à la ligne du texte, les trois phrases se collaient.
 *
 * @param {string} summary  ce qui va partir (« Vous allez envoyer un SMS à … »)
 * @param {'sms'|'email'} channel
 * @returns {Promise<boolean|null>} true = retard, false = pas un retard, null = annulé
 */
const askDelayAndConfirm = (summary, channel) => {
  const content = document.createElement("div");
  content.style.whiteSpace = "pre-line";
  content.style.textAlign = "left";
  content.style.color = "rgba(0, 0, 0, 0.64)";
  content.textContent = summary
    + "\n\nOui : il sera aussi affiché au client dans l'app, sur le suivi de sa commande."
    + "\nNon : il part seulement par " + (channel === "sms" ? "SMS." : "email.");

  return swal({
    title: "Ce message annonce-t-il un retard ?",
    content: content,
    icon: "warning",
    buttons: {
      cancel: "Annuler",
      no: { text: "Non, envoyer", value: "no" },
      yes: { text: "Oui, c'est un retard", value: "yes" },
    },
  }).then((answer) => (answer === "yes" ? true : answer === "no" ? false : null));
};

export default askDelayAndConfirm;
